import React from "react";
import "../styles/sobremi.css";
import fotoVicky from "../images/sobremi.jpeg"; 
import angel1 from "../images/sobremi1.png";         // ángel decorativo 1
import angel2 from "../images/sobremi2.png";  

export default function Sobremi() {
  return (
    <section id="sobremi" className="sobremi-section">

      {/* Imagen a la izquierda */}
      <div className="sobremi-imagen">
        <img src={fotoVicky} alt="Vicky" />
      </div>

      {/* Texto a la derecha */}
      <div className="sobremi-texto">
        <h2 className="sobremi-titulo">Sobre Mí</h2>
        <p>
          Desde que tenía 4 años descubrí que no estaba sola: los ángeles me acompañaban
          como amigos invisibles, jugando, guiándome y susurrando mensajes que aprendí a
          escuchar. Con el tiempo entendí que ese don era mi misión.
        </p>

        <p>
          A los 16 años inicié mi camino en el Reiki y más tarde en la lectura de cartas
          angélicas, profundizando en sanaciones, energizaciones y limpiezas que hoy me
          permiten acompañar a quienes buscan claridad y equilibrio.
        </p>

        <p>
          Mi vida siempre estuvo marcada por el arte y la danza, expresiones que uní con la
          energía angelical para desbloquear emociones y conectar con el alma desde lo más
          profundo.
        </p>

        <p>
          Hoy, después de más de tres décadas de experiencia, me dedico a ser puente entre
          vos y los ángeles, para que puedas sentir su presencia, escuchar sus mensajes y
          transformar tu vida con su luz.
        </p>
      </div>

            {/* Ángeles decorativos — SOLO dentro de la sección */}
      <img src={angel1} alt="Ángel decorativo 1" className="angel-sobremi angel-izquierda" />
      <img src={angel2} alt="Ángel decorativo 2" className="angel-sobremi angel-derecha" />
 
    </section>
  );
}
